import React from 'react';
import * as T from 'prop-types';

import { SelectableListProps } from '../../AuPropTypes';
import { NOOP, fsmType } from '../../constants';
import FilterSelectableList from "./FilterSelectableList";

export default class FSMselect extends React.Component {

  static propTypes = {
    defaultValue: SelectableListProps.defaultValue,
    containerRef: SelectableListProps.containerRef,
    selection: SelectableListProps.selection,
    sort: SelectableListProps.sort,
    multiSelect: T.bool,
    onChange: T.func,
    onInit: T.func
  }

  static defaultProps = {
    onChange: NOOP,
    onInit: NOOP,
    selection: []
  }

  FsmSelectItems = Object.keys(fsmType).map(value => (
    { displayId: `au.entity.attr.fsmName.${value}`, value }
  ));

  render() {
    return (
      <FilterSelectableList
        containerRef={this.props.containerRef}
        items={this.FsmSelectItems}
        sort={this.props.sort}
        defaultValue={this.props.defaultValue}
        selection={this.props.selection}
        multiSelect={this.props.multiSelect}
        onChange={this.props.onChange}
        onInit={this.props.onInit}
      />
    );
  }

}
